import {createSelector} from "reselect";


export const getRulesSelector = (state) => {
    if(!state.object.rules) return
    let rules = {...state.object.rules}
    delete rules["checkIn"]
    delete rules["checkOut"]
    return rules
}

export const getCheckInSelector = (state) => {
    if(!state.object.rules) return
    return state.object.rules.checkIn
}

export const getCheckOutSelector = (state) => {
    if(!state.object.rules) return
    return state.object.rules.checkOut
}


export const selectedCheckInSelector = createSelector(getCheckInSelector, (checkIn) => {
    if(!checkIn) return;
    let selectedCheckIn =  checkIn.values.filter(item => item.selected)[0];
    return selectedCheckIn ? selectedCheckIn.value : undefined
})

export const selectedCheckOutSelector = createSelector(getCheckOutSelector, (checkOut) => {
    if(!checkOut) return
    let selectedCheckOut =  checkOut.values.filter(item => item.selected)[0];
    return selectedCheckOut ? selectedCheckOut.value : undefined
})




